import React, { Component } from 'react';
import AppContext from '../../AppContext';
import cx from 'classnames';
import { Grid, GridAlignment, GridDirection, GridJustify } from '@riotgames/accounts-react-components/lib/Grid';
import { GridPanel } from '@riotgames/accounts-react-components/lib/Grid/GridPanel';
import { WEB_BODY2_CLASS } from '@riotgames/accounts-react-components/lib/Typography';
import ButtonLogin from './ButtonLogin';
import './accountCreation.scss';

class Success extends Component {
  static contextType = AppContext;
  update(params) {
    const { actions } = this.context;
    actions.setData(params);
  }

  render() {
    const {
      state: { username, signupType }
    } = this.context;

    const titleGridPanel = signupType === 'PROMOTION' ? '업그레이드 완료' : '계정 생성 완료';
    const subTitleGridPanel =
      signupType === 'PROMOTION' ? (
        <p className="help-text">이제 Google/Apple 계정 혹은 아이디와 비밀번호를 이용하여 로그인하실 수 있습니다.</p>
      ) : (
        <p className="help-text">
          라이엇 계정 생성이 완료되었습니다. <br />
          이제 게임으로 돌아가 로그인 하실 수 있습니다.
        </p>
      );

    const ButtonOfPanel =
      signupType === 'PROMOTION' ? (
        <p className={cx(WEB_BODY2_CLASS, 'button-text-anchor')}>이 창은 닫으셔도 됩니다.</p>
      ) : (
        <ButtonLogin />
      );

    return (
      <GridPanel title={titleGridPanel} subTitle={subTitleGridPanel} button={ButtonOfPanel}>
        <Grid direction={GridDirection.vertical} align={GridAlignment.center} justify={GridJustify.center} fill={true}>
          <p className="help-text__label">계정이름</p>
          <h2 className="help-text__primary">{username}</h2>
        </Grid>
      </GridPanel>
    );
  }
}

export default Success;
